import { OrderDriveSummary, PlanDriveSummary, PlanFolderSummary } from './types';

const folderLinks = (summary: OrderDriveSummary): (string | null | undefined)[] => [
  summary.drop?.folderLink,
  ...summary.bookings.flatMap((booking) => [
    booking.folderLink,
    ...booking.decorations.map((decoration) => decoration.folderLink),
  ]),
];

/**
 * Part of the order's tree exists and part does not yet: the worker creates a new booking's or decoration's folder
 * seconds after the change. An order with no folder at all (finished before Drive, nothing to move) waits for nothing.
 * The backend's `preparing` decides when it is there, since it also sees bookings this screen may not list.
 */
export const awaitsProvisioning = (summary: OrderDriveSummary | undefined): boolean => {
  if (!summary) return false;
  if (summary.preparing !== undefined) return summary.preparing;
  const links = folderLinks(summary);

  return links.some(Boolean) && links.some((link) => !link);
};

/** A plan line as its Drive folder is keyed: a space or package line by its id, a package member by its package line and space. */
export interface PlanLine {
  planBookingId: string;
  spaceId?: string;
}

export const planFolderOf = (
  summary: PlanDriveSummary,
  { planBookingId, spaceId }: PlanLine,
): PlanFolderSummary | undefined =>
  summary.folders.find(
    (folder) => folder.planBookingId === planBookingId && (folder.spaceId ?? undefined) === spaceId,
  );
